import { useEffect as u, useLayoutEffect as b, useRef as l, useCallback as d, useMemo as m } from "react";
const S = () => {
}, E = typeof window > "u" ? u : b;
function a(t) {
  const e = l(t);
  return E(() => {
    e.current = t;
  }, [t]), e;
}
function p(t) {
  const e = a(t);
  return d((...n) => e.current(...n), [e]);
}
function y(t) {
  const e = a(t);
  return m(() => e.current, [e]);
}
function g(t, e, n) {
  const r = p(e), s = y(n);
  u(() => {
    if (!s?.disabled)
      try {
        const c = t.current;
        if (!c)
          return;
        const o = new IntersectionObserver((f) => {
          f.forEach((i) => {
            r(i.isIntersecting);
          });
        }, s);
        return o.observe(c), () => o.unobserve(c);
      } catch {
        return r(!0), () => r(!1);
      }
  }, [r, s, t]);
}
function h(...t) {
  return (e) => {
    t.forEach((n) => {
      n && (typeof n == "function" ? n(e) : n.current = e);
    });
  };
}
export {
  S as N,
  p as a,
  E as b,
  a as c,
  y as d,
  h as m,
  g as u
};
//# sourceMappingURL=index-615eb227.mjs.map
